export default "__VITE_ASSET__BhVaswin__"